<template>
	<div style="padding: 20px;">
		<el-form label-position="right" label-width="145px" :model="formdata" :rules="rules" ref="formdata">
			<div class="thead">亲子家庭活动分享统计表</div>
			<el-row :gutter="20">
				<el-col :span="8">
					<el-form-item label="分享奖励设定" prop="set">
						<el-input v-model="formdata.set" size="small"></el-input>
						<el-input v-model="formdata.f_id" style="display: none;"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="活动分享关键词" prop="key_word">
						<el-input v-model="formdata.key_word" size="small"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="8">
					<el-form-item label="平均集赞数量" prop="agv_laud">
						<el-input v-model.number="formdata.agv_laud" size="small"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="分享亲子家庭数量" prop="share">
						<el-input v-model.number="formdata.share" size="small"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<div class="upload">
					<input @change="fileChange($event)" accept="image/jpeg,image/jpg" type="file" id="upload_file" multiple style="display: none" />
					<div class="add-img" v-show="imgList.length">
						<p class="font14" style="margin-bottom: 10px">图片(最多8张，还可上传<span v-text="8-imgList.length"></span>张)</p>
						<ul class="img-list">
							<li v-for="(url,index) in imgList">
								<img class="del" src="/static/qmsj/img/delpng.png" @click.stop="delImg(index)" />
								<img class="yulantu" :src="url.file.src">
							</li>
						</ul>
					</div>
					<div class="add" @click="chooseType">
						<div class="add-image" align="center">
							<i class="el-icon-plus avatar-uploader-icon"></i>
						</div>
						<p style="padding-top: 5px;text-align: center;">朋友圈分享截图</p>
					</div>

				</div>
			</el-row>
			<div class="thead">活动数据反馈表</div>
			<el-row :gutter="20">
				<el-col :span="6">
					<el-form-item label="活动名称">
						<el-input v-model="formdata.name" size="small" disabled></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="活动日期" >
						<el-input v-model="formdata.date" size="small" disabled></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="活动地点" prop="site">
						<el-input v-model="formdata.site" size="small"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="活动场数" prop="farm_num">
						<el-input v-model.number="formdata.farm_num" size="small"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="6">
					<el-form-item label="非会员人数" prop="no_vip">
						<el-input v-model.number="formdata.no_vip" size="small" style="width:85%"></el-input>
						<span>{{dataset.on_vip}}</span>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="报名人数" prop="enroll">
						<el-input v-model.number="formdata.enroll" size="small" style="width:85%"></el-input>
						<span>{{dataset.enroll}}</span>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="参与人数" prop="join">
						<el-input v-model.number="formdata.join" size="small" style="width:85%"></el-input>
						<span>{{dataset.join}}</span>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="会员人数" prop="vip">
						<el-input v-model.number="formdata.vip" size="small" style="width:85%"></el-input>
						<span>{{dataset.vip}}</span>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="6">
					<el-form-item label="新增会员人数" prop="add_vip">
						<el-input v-model.number="formdata.add_vip" size="small"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="活动预算" prop="budget">
						<el-input v-model.number="formdata.budget" size="small"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="实际费用" prop="actual">
						<el-input v-model.number="formdata.actual" size="small"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="转化率" prop="lv">
						<el-input v-model.number="formdata.lv" size="small"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="12">
					<el-form-item label="活动宣传渠道" prop="propagate">
						<el-input type="textarea" v-model="formdata.propagate" size="small"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="活动渠道" prop="channels">
						<el-input type="textarea" v-model="formdata.channels" size="small"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="12">
					<el-form-item label="家长反馈意见" prop="feedback">
						<el-input type="textarea" v-model="formdata.feedback" size="small"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="活动效果" prop="effect">
						<el-input type="textarea" v-model="formdata.effect" size="small"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="12">
					<el-form-item label="活动总结" prop="summary">
						<el-input type="textarea" v-model="formdata.summary" size="small"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="其他" prop="other">
						<el-input type="textarea" v-model="formdata.other" size="small"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<div class="but">
				<el-button type="success" @click="finallys('formdata')">确认</el-button>
			</div>
		</el-form>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				token: '',
				fid: '',
				dataset: '',
				formdata: {
					f_id: '',
					set: '', // 分享奖励设定
					key_word: '', // 活动分享关键词
					agv_laud: '', // 平均集赞数量
					share: '', // 参与分享的亲子家庭数量
					name: '', //活动名称
					date: '', //活动日期
					site: '', // 活动地点
					farm_num: '', // 活动场次
					no_vip: '', // 非会员人数
					enroll: '', // 报名人数
					join: '', // 参与人数
					vip: '', // 会员人数
					add_vip: '', // 新增会员人数
					budget: '', // 活动预算
					actual: '', // 实际费用
					lv: '', // 转化率
					propagate: '', // 活动宣传渠道
					channels: '', // 活动渠道
					feedback: '', // 家长反馈意见
					effect: '', // 活动效果
					summary: '', // 活动总结
					other: '', // 其他
				},
				rules: {
					set: [{required: true,message: '分享奖励设定不能为空',trigger: 'blur'}, ],
					site: [{required: true,message: '活动场地不能为空',trigger: 'blur'}, ],
					key_word: [{required: true,message: '活动分享关键词不能为空',trigger: 'blur'}, ],
					agv_laud: [{ required: true, message: '平均集赞数量不能为空'},{ type: 'number', message: '平均集赞数量必须为数字'}],
					share: [{ required: true, message: '参与分享的亲子家庭数量不能为空'},{ type: 'number', message: '参与分享的亲子家庭数量必须为数字'}],
					no_vip: [{ required: true, message: '非会员人数不能为空'},{ type: 'number', message: '非会员人数必须为数字'}],
					farm_num: [{ required: true, message: '活动场次不能为空'},{ type: 'number', message: '必须为数字'}],
					enroll: [{ required: true, message: '报名人员不能为空'},{ type: 'number', message: '报名人员必须为数字'}],
					join: [{ required: true, message: '活动场次不能为空'},{ type: 'number', message: '活动场次必须为数字'}],
					vip: [{ required: true, message: '会员人数不能为空'},{ type: 'number', message: '会员人数必须为数字'}],
					add_vip: [{ required: true, message: '新增会员人数不能为空'},{ type: 'number', message: '新增会员人数必须为数字'}],
					budget: [{ required: true, message: '活动预算不能为空'},{ type: 'number', message: '活动预算必须为数字'}],
					actual: [{ required: true, message: '实际费用不能为空'},{ type: 'number', message: '实际费用必须为数字'}],
					lv: [{ required: true, message: '转化率不能为空'},{ type: 'number', message: '转化率必须为数字'}],
				},
				imgList: [],
				size: 0,
				limit: 8, //限制图片上传的数量
				tempImgs: [],
				contents: '',
			};
		},
		mounted: function() {
			var self = this
			self.token = self.$cookies.get("token")
			self.fid = self.$route.query.id
			self.formdata.f_id = self.fid
			$.ajax({
				url: process.env.apiUrl + "saas/plan/backsee",
				type: "post",
				async: false,
				data: {
					token: self.token,
					f_id: self.fid
				},
				success: function(data) {
					console.log(data)
					self.dataset = data.data
					self.formdata.name = data.data.title
					self.formdata.date = data.data.start_time
				}
			})
		},
		methods: {
			buta: function(i) {
				this.idx = i
			},
			// 跳转
			jump: function(e, id) {
				this.$router.push({
					name: e,
					queray: {
						id: id
					}
				})
			},
			fanye: function(i) {
				alert(i)
			},
			// 最终提交
			finallys: function(formdata) {
				this.$refs[formdata].validate((valid) => {
					if (valid) {

						let self = this
						let contents_img = []
						for (var i = 0; i < this.imgList.length; i++) {
							var img = this.imgList[i].file.src
							contents_img.push(img);
						}
						self.contents = contents_img
						const loading = this.$loading({
							lock: true,
							text: '提交中',
							spinner: 'el-icon-loading',
							background: 'rgba(0, 0, 0, 0.7)'
						});
						$.ajax({
							url: process.env.apiUrl + "saas/plan/foodback",
							type: "post",
							async: false,
							data: {
								token: self.token,
								f_id: self.formdata.f_id, //id
								set: self.formdata.set, // 分享奖励设定
								key_word: self.formdata.key_word, // 活动分享关键词
								agv_laud: self.formdata.agv_laud, // 平均集赞数量
								share: self.formdata.share, // 参与分享的亲子家庭数量
								name: self.formdata.name, //活动名称
								date: self.formdata.date, //活动日期
								site: self.formdata.site, // 活动地点
								farm_num: self.formdata.farm_num, // 活动场次
								no_vip: self.formdata.no_vip, // 非会员人数
								enroll: self.formdata.enroll, // 报名人数
								join: self.formdata.join, // 参与人数
								vip: self.formdata.vip, // 会员人数
								add_vip: self.formdata.add_vip, // 新增会员人数
								budget: self.formdata.budget, // 活动预算
								actual: self.formdata.actual, // 实际费用
								lv: self.formdata.lv, // 转化率
								propagate: self.formdata.propagate, // 活动宣传渠道
								channels: self.formdata.channels, // 活动渠道
								feedback: self.formdata.feedback, // 家长反馈意见
								effect: self.formdata.effect, // 活动效果
								summary: self.formdata.summary, // 活动总结
								other: self.formdata.other, // 其他
								image: self.contents, //图片
							},
							success: function(data) {
								console.log(data)
								if (data.status == 1) {
									loading.close();
									setTimeout(() => {
										self.$message({
											message: '提交反馈成功！',
											type: 'success'
										});
										self.$router.push('zbhd')
									}, 1000);
								} else if (data.status == 2) {
									self.$message.error(data.msg);
									loading.close();
								}
							}
						})


					} else {
						console.log('error submit!!');
						return false;
					}
				});

			},
			// ***************上传图片************************
			chooseType() {
				document.getElementById('upload_file').click();
			},
			fileChange(el) {
				if (!el.target.files[0].size) return;
				this.fileList(el.target);
				el.target.value = ''
			},
			fileList(fileList) {
				let files = fileList.files;
				for (let i = 0; i < files.length; i++) {
					//判断是否为文件夹
					if (files[i].type != '') {
						this.fileAdd(files[i]);
					} else {
						//文件夹处理
						this.folders(fileList.items[i]);
					}
				}
			},
			//文件夹处理
			folders(files) {
				let _this = this;
				//判断是否为原生file
				if (files.kind) {
					files = files.webkitGetAsEntry();
				}
				files.createReader().readEntries(function(file) {
					for (let i = 0; i < file.length; i++) {
						if (file[i].isFile) {
							_this.foldersAdd(file[i]);
						} else {
							_this.folders(file[i]);
						}
					}
				});

			},
			foldersAdd(entry) {
				let _this = this;
				entry.file(function(file) {
					_this.fileAdd(file)
				})
			},
			fileAdd(file) {
				console.log(file)
				if (this.limit !== undefined) this.limit--;
				if (this.limit !== undefined && this.limit < 0) return;
				//总大小
				this.size = this.size + file.size;
				//判断是否为图片文件
				if (file.type.indexOf('image') == -1) {
					this.$dialog.toast({
						mes: '请选择图片文件'
					});
				} else {
					let reader = new FileReader();
					let image = new Image();
					let _this = this;
					reader.readAsDataURL(file);
					reader.onload = function() {
						file.src = this.result;
						image.onload = function() {
							let width = image.width;
							let height = image.height;
							file.width = width;
							file.height = height;
							_this.imgList.push({
								file
							});
							console.log(_this.imgList);
						};
						image.src = file.src;

					}
				}
			},
			delImg(index) {
				this.size = this.size - this.imgList[index].file.size; //总大小
				this.imgList.splice(index, 1);
				if (this.limit !== undefined) this.limit = 6 - this.imgList.length;
			},
			displayImg() {

			},

			// **************上传图片*************************

		},
		filters: {

		},
		watch: { //watch()监听某个值（双向绑定）的变化，从而达到change事件监听的效果

		},
	}
</script>

<style scoped>
	.thead {
		border-left: 4px solid #8CBB77;
		margin-top: 15px;
		margin-bottom: 10px;
		height: 25px;
		line-height: 25px;
		font-size: 18px;
		padding-left: 12px;
	}

	.el-form-item__label {
		font-size: 12px;
	}

	.form1 {
		padding-bottom: 20px;
	}

	.upload {
		padding: 0px 30px;
	}

	.but {
		padding: 10px;
		text-align: center;
	}

	button {
		width: 211px;
		height: 50px;
		border-radius: 25px;
		background: #8CBB77;
		color: white;
		font-size: 16px;
		cursor: pointer;
		border: 0;
		outline: none;
	}

	button:hover {
		background: #8CBB77;
		color: white;
	}

	.add-img {
		width: 100%;
		padding: 10px;
	}

	.add-img p {
		color: #999;
	}

	.add {
		display: inline-block;
		margin-bottom: 20px;
	}

	.add-image {
		/*padding-top: 15px;*/
		margin-left: 10px;
		text-align: center;
		line-height: 100px;
		font-size: 50px;
		width: 100px;
		top: 20px;
		height: 100px;
		border: 1px dashed rgba(0, 0, 0, .2);
	}

	.add-image .icon-camera {
		font-size: 24px;
	}

	.good-item .choose {
		color: #fff;
		background-color: #87582E;
		border: 0;
	}

	.mui-btn-block {
		border: 0;
		border-radius: 0;
		background-color: #87582E;
		color: #fff;
		margin-bottom: 0;
		bottom: 0;
	}

	.mui-buttom {
		position: fixed;
		width: 100%;
		bottom: 0;
		z-index: 999;

	}

	/*九宫格*/
	.img-list {
		overflow: hidden;
	}

	.img-list>li {
		float: left;
		width: 100px;
		height: 100px;
		text-align: center;
		position: relative;
		margin-right: 5px;
	}

	.img-list>li>div {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		overflow: hidden;
	}

	.img-list>li>div .app-bg {
		width: 100%;
		height: 100%;
	}

	.mui-fullscreen {
		z-index: 9999;
	}

	.del {
		position: absolute;
		width: 18px;
		top: 0;
		right: 0;
		z-index: 999
	}

	.xiala {
		width: 200px;
		height: 32px;
		line-height: 32px;
		background-color: #fff;
		background-image: none;
		border-radius: 4px;
		border: 1px solid #dcdfe6;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		color: #606266;
		display: inline-block;
		font-size: 13px;
		outline: 0;
		padding: 0 15px;
		-webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
		transition: border-color .2s cubic-bezier(.645, .045, .355, 1);

	}

	.yulantu {
		width: 100%;
		height: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/huodong/fangkui.vue